module.exports = __webpack_public_path__ + "static/img/8-2.dd3efb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/img/8-2.png
// module id = Rjje
// module chunks = 10